export const CheckMarkIcon = props => (
  <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M7.49953 11.3782L14.3938 4.48389L15.4545 5.54454L7.49953 13.4995L2.72656 8.72655L3.78723 7.6659L7.49953 11.3782Z'
      fill='#3E8E41'
    />
  </svg>
);
